import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const whereSummary = api((regimeId, group, filters = []) =>
    query(
        gql`
            query WhereSummary($regimeId: String!, $group: String, $filters: [JSONObject]) {
                regimeAssetTaskSummary(regimeId: $regimeId, group: $group, filters: $filters) {
                    id
                    summarise(by: ["where"]) {
                        summary(take: 500) {
                            value
                            count
                            tasks {
                                items(take: 1) {
                                    scheduleId
                                }
                            }
                        }
                    }
                }
            }
        `,
        { regimeId, group, filters: [{ "frequency.label": "0U" }, ...filters] },
        { returns: "regimeAssetTaskSummary" }
    )
)
